import { faker } from '@faker-js/faker/locale/en';

const hashSeed = (seed: string): number => {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash << 5) - hash + seed.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

const applySeed = (columnName: string, seed: string | number) => {
  const seedKey = `${seed}-${columnName}`;
  faker.seed(hashSeed(seedKey));
};

export const generateRandomPlaceholder = (
  columnName: string,
  seed?: string | number
): string => {
  if (seed !== undefined) {
    applySeed(columnName, seed);
  }

  switch (columnName) {
    case 'last_name':
      return faker.person.lastName();
    case 'email':
      return faker.internet.email();
    case 'personal_email':
      return faker.internet.email();
    case 'phone_number':
      return faker.phone.number();
    case 'linkedin_url':
      return `linkedin.com/in/${faker.internet.userName()}`;
    default:
      return '';
  }
};
